const authNavigation = [
  {
    path: "/admin/users",
    name: "Users List"
  },
  {
    path: "/admin/create-post",
    name: " Manage Books"
  },
  {
    path: "/admin/coloring-sheets",
    name: " Manage Coloring Sheets"
  },
  {
    path: "/admin/activity-sheets",
    name: " Manage Acitvity Sheets"
  },
  {
    path: "/admin/extra-sheets",
    name: " Extra "
  },
  {
    path: "/admin/toys",
    name: "Toys"
  },
  {
    path: "/admin/general-toys",
    name: "General Toys"
  },
  {
    path: "/admin/bundles",
    name: "Bundles"
  },
  {
    path: "/admin/blogs",
    name: " Blogs"
  },
  {
    path: "/admin/orders",
    name: " Orders"
  },
  {
    path: "/admin/faqs",
    name: " Faqs"
  },
 

  {
    path: "/admin/reviews",
    name: "Reviews"
  },
]

export default authNavigation;